import template from './atm_load_profile.edit.html';
import controller from './atm_load_profile.edit.controller';
import './atm_load_profile.edit.scss';

let ATMLoadProfileEditComponent = {
  restrict: 'E',
  bindings: {
    hasACL:'='
  },
  template,
  controller
};

export default ATMLoadProfileEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/atm_load_profile/edit/atm_load_profile.edit.component.js